export default [
  require('/home/runner/work/autoviews/autoviews/website/node_modules/infima/dist/css/default/default.css'),
  require('/home/runner/work/autoviews/autoviews/website/node_modules/@docusaurus/theme-classic/lib/prism-include-languages'),
  require('/home/runner/work/autoviews/autoviews/website/node_modules/@docusaurus/theme-classic/lib/nprogress'),
  require('/home/runner/work/autoviews/autoviews/website/src/css/custom.css'),
  require('/home/runner/work/autoviews/autoviews/website/node_modules/@codesandbox/sandpack-react/dist/index.css'),
];
